/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Salary_DataInputs */

const en_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary data`)
};

const de_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehaltsdaten`)
};

const fr_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données salariales`)
};

const es_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos salariales`)
};

const it_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati salariali`)
};

const nl_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salarisgegevens`)
};

const pl_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane o wynagrodzeniach`)
};

const fi_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkkatiedot`)
};

const da_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Løndata`)
};

const sv_pricing_compare_salary_data = /** @type {(inputs: Pricing_Compare_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lönedata`)
};

/**
* | output |
* | --- |
* | "Salary data" |
*
* @param {Pricing_Compare_Salary_DataInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_salary_data = /** @type {((inputs?: Pricing_Compare_Salary_DataInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Salary_DataInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_salary_data(inputs)
	if (locale === "fr") return fr_pricing_compare_salary_data(inputs)
	if (locale === "es") return es_pricing_compare_salary_data(inputs)
	if (locale === "it") return it_pricing_compare_salary_data(inputs)
	if (locale === "nl") return nl_pricing_compare_salary_data(inputs)
	if (locale === "pl") return pl_pricing_compare_salary_data(inputs)
	if (locale === "fi") return fi_pricing_compare_salary_data(inputs)
	if (locale === "da") return da_pricing_compare_salary_data(inputs)
	if (locale === "sv") return sv_pricing_compare_salary_data(inputs)
	return en_pricing_compare_salary_data(inputs)
});